import {withJsonFormsControlProps} from '@jsonforms/react';
import DropdownControl from './DropdownControl';
export default withJsonFormsControlProps(DropdownControl);
